var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.width > 1024)?_c('navlist',{staticStyle:{"margin":"54px 0 0 0","z-index":"100"}}):_c('mobilenav',{staticStyle:{"margin":"0"}}),_c('router-view'),(_vm.width > 1024)?_c('footlist',{staticStyle:{"margin":"0"}}):_c('mobilefoot',{staticStyle:{"margin":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }